import React, { Component } from 'react';
import ValidadorDeProductos from './components/ValidadorDeProductos';
import Redireccion from './components/Redireccion';
import { BrowserRouter, Route } from 'react-router-dom';
import ViewDocument from './components/ViewDocument';

import './custom.css'

export default class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Route
          exact
          path='/verificacion'
          component={ValidadorDeProductos} />

        <Route
          exact
          path='/verificacion/:guid'
          component={Redireccion} />

        <Route
          exact
          path='/viewDocument'
          component={ViewDocument} />
      </BrowserRouter>
    );
  }
}
